import { mapState, mapActions, mapMutations } from "vuex";
import NguyenVong from "../screen/NguyenVong.vue";
import ThongTinTHPT from "../screen/ThongTinTHPT.vue";
import ThongTinDangKy from "../screen/ThongTinDangKy.vue";
import ThongTinDangKyCaoHoc from "../screen/ThongTinDangKyCaoHoc.vue";
import KhaoSat from "../screen/KhaoSat.vue";
import ThongBaoThanhCong from "../screen/ThongBaoThanhCong.vue"
import DialogLoader from "@/components/dialog/DialogLoader.vue"
import DangKyCaoHoc from "../screen/DangKyCaoHoc.vue"
import DatePicker from "@/components/DatePicker.vue"

const axios = require("axios");
import { extend } from "vee-validate";
import { _message } from "@/helpers/_message"

const focus = {
	inserted(el) {
		el.focus()
	},
}

var checkExistCmnd = (soCmnd) => {
	return axios
		.get(
			`${process.env.VUE_APP_API}${process.env.VUE_APP_THISINH}${process.env.VUE_APP_CHECKCMND}`,
			{
				params: { soCmnd: soCmnd },
			},
		)
		.then((response) => response)
		.catch((error) => error.response);
};
extend("checkExistCmnd", {
	async validate(value, params) {
		if (value.length > 0) {
			let thiSinhId = params[0];
			let soCmnd = params[1];
			let existCmnd = await checkExistCmnd(value);
			if (thiSinhId > 0) {
				// dang ky lai
				if (existCmnd.data) {
					return value == soCmnd;
				} return value != soCmnd;
			} else {
				// dang ky moi
				return !existCmnd.data;
			}
		}
	},
	message: "{_field_} đã tồn tại",
});
var checkExistSbd = (sbd) => {
	return axios
		.get(
			`${process.env.VUE_APP_API}${process.env.VUE_APP_THISINH}${process.env.VUE_APP_CHECKSBD}`,
			{
				params: { sbd: sbd },
			},
		)
		.then((response) => response)
		.catch((error) => error.response);
};
extend("checkExistSbd", {
	async validate(value, params) {
		if (value.length > 0) {
			let thiSinhId = params[0];
			let sbd = params[1];
			let existCmnd = await checkExistSbd(value);
			if (thiSinhId > 0) {
				// dang ky lai
				if (existCmnd.data) {
					return value == sbd;
				} return value != sbd;
			} else {
				// dang ky moi
				return !existCmnd.data;
			}
		}
	},
	message: "{_field_} đã tồn tại",
});

export default {
	directives: { focus },
	components: {
		NguyenVong,
		ThongTinTHPT,
		ThongTinDangKy,
		KhaoSat,
		ThongBaoThanhCong,
		DialogLoader,
		DangKyCaoHoc,
		ThongTinDangKyCaoHoc,
		DatePicker,
	},
	props: {
		screenAction: {
			type: String,
			default: "DangKy"
		},
	},
	data() {
		return {
			xettuyens: [],
			danhsachmons: {},
			songuyenvong: 1,
			length_CMND: 9,
			soCmnd: "",
			title: "",
			loaiDot: "HOCBA",
			isScreen: 1, // 1: Màn hình đăng ký - chỉnh sửa, 2: màn hình xem lại kết quả, 3: thông báo thành công
			review: "",
			fileHocBa: null,
			khaosat: 1,
			isThongBao: false,
			httpDownloadFileHocBa: "",
			sbd: ""
		};
	},
	computed: {
		...mapState({
			nganhs: (state) => state.nganh.nganhs,
			nguyenvongs: (state) => state.nguyenvong.nguyenvongs,
			diems: (state) => state.tohop.diems,
			tinhs: (state) => state.truong.tinhs,
			thisinh: (state) => state.thisinh.thisinh,
			mons: (state) => state.tohop.mons,
			dotdangky: (state) => state.dotdangky.dotdangky,
			khaosats: (state) => state.khaosat.khaosats,
			cosoes: (state) => state.coso.cosoes,
			dotdangkythisinh: (state) => state.dotdangkythisinh.dotdangkythisinh,

		}),
	},
	methods: {
		...mapActions({
			getNganhs: "nganh/getNganhs",
			createNguyenVongs: "nguyenvong/createNguyenVongs",
			dangKyThiSinh: "thisinh/dangKyThiSinh",
			getTinhs: "truong/getTinhs",
			updateThiSinh: "thisinh/updateThiSinh",
			createDotDangKyThiSinh: "dotdangkythisinh/createDotDangKyThiSinh",
			getCoSoes: "coso/getCoSoes",
			downloadFileDangKy: "thisinh/downloadFileDangKy",
			downloadFileHoSo: "thisinh/downloadFileHoSo",
		}),
		...mapMutations({
			themNguyenVong: "nguyenvong/themNguyenVong",
			themKhaoSat: "khaosat/themKhaoSat",
		}),
		clickDownFileDangKy(regCode) {
			this.$root.$dialogLoader.show(this.$t("message.download.title"), {},);
			this.downloadFileDangKy(regCode).then(response => {
				if (response.status === 404) {
					_message.messageNotHaveFileDownload();
				}
				this.$root.$dialogLoader.hide();
			});
		},
		clickDownFileHoSo(thiSinhId) {
			this.$root.$dialogLoader.show(this.$t("message.download.title"), {},);
			this.downloadFileHoSo(thiSinhId).then(response => {
				if (response.status === 404) {
					_message.messageNotHaveFileDownload();
				}
				this.$root.$dialogLoader.hide();
			});
		},
		dangKy() {
			this.$refs.form.validate().then((success) => {
				if (!success) {
					_message.notFill();
					return;
				}
				this.isScreen = 2;
				this.review = this.$t("models.dotDangKy.thongTin")
			});
		},

		saveAs(uri, filename) {
			var link = document.createElement("a");
			if (typeof link.download === "string") {
				link.href = uri;
				link.download = filename;

				//Firefox requires the link to be in the body
				document.body.appendChild(link);

				//simulate click
				link.click();

				//remove the link when done
				document.body.removeChild(link);
			} else {
				window.open(uri);
			}
		},
		comeBack(value) {
			if (value == "dang_ky_xong") this.isScreen = 3;
			else {
				this.isScreen = 1;
				if (this.screenAction == "DangKy") this.$t("models.dotDangKy.dangKy");
				else this.review = this.$t("models.dotDangKy.thayDoi");
			}
		},
		handleFileChange(event) {
			this.fileHocBa = event.target.files[0].name;
		},
		checkTypeFile(value, type) {
			if (!value) return false;
			return value.includes(type);
		}
	},
	async created() {
		await this.getCoSoes();
		if (this.screenAction == "DangKy") {
			await this.$store
				.dispatch("dotdangky/getDotDangKy", [this.$route.params.dotDangKyId])
				.then(async (response) => {
					if (response.status === 200) {
            this.title = response.data.tenDot;
            this.loaiDot = response.data.loaiDot;
						let today = await new Date();
						let ngayBatDau = await new Date(response.data.ngayBatDau);
						let ngayKetThuc = await new Date(response.data.ngayKetThuc);
						await [today, ngayBatDau, ngayKetThuc].map((item) =>
							item.setHours(0, 0, 0, 0),
						);
						switch (true) {
							case today < ngayBatDau:
								_message.messageDangKyFalse(1);
								this.$router.push({ name: "dot-dang-ky" });
								break;
							case today > ngayKetThuc:
								this.$swal
								_message.messageDangKyFalse(2);
								this.$router.push({ name: "dot-dang-ky" });
								break;
							default:
								break;
						}
					} else {
						_message.messageDangKyFalse(3);
						this.$router.push({ name: "dot-dang-ky" });
					}
				});
			let getInformation = [
				this.$store.commit("nguyenvong/loadNew"),
				this.$store.commit("tohop/loadNew"),
				this.$store.commit("khaosat/loadNew"),
				this.getNganhs(this.$route.params.dotDangKyId),
				this.getTinhs(),
			];
			let thisinh = this.$store.state.thisinh.thisinh;
			if (thisinh.thiSinhId) {
				await [10, 11, 12].forEach((item) => {
					getInformation.push(
						this.$store.dispatch("truong/getTinhsTruongId", {
							truongId: thisinh[`lop${item}TruongId`],
							lop: item,
						}),
					);
				});
			} else {
				// getInformation.push(this.$store.commit("thisinh/loadNew"));
				getInformation.push(this.$store.commit("truong/loadNew"));
			}
			await Promise.all(getInformation)
				.then(() => { })
				.catch((error) => {
					console.error(error, "error");
				});
			this.soCmnd = this.thisinh.soCmnd;
			this.sbd = this.thisinh.sbd;
		} else {
			this.review = this.$t("models.dotDangKy.thayDoi");
			this.title = this.dotdangky.tenDot;
			this.loaiDot = this.dotdangky.loaiDot;
			if (this.thisinh.soCmnd.length === 9 || this.thisinh.soCmnd.length === 12) {
				this.length_CMND = this.thisinh.soCmnd.length;
			}
			await this.getNganhs(this.dotdangky.dotDangKyId),
				this.soCmnd = this.thisinh.soCmnd;
			this.sbd = this.thisinh.sbd;
		}
		this.httpDownloadFileHocBa = `${process.env.VUE_APP_API}${process.env.VUE_APP_DOWNLOAD}/hocba`;

	},
	async beforeCreate() {
	},
	async destroyed() {
		this.soCmnd = "";
		this.sbd = "";
		let getInformation = [
			this.$store.commit("nguyenvong/loadNew"),
			this.$store.commit("tohop/loadNew"),
			this.$store.commit("thisinh/loadNew"),
			this.$store.commit("truong/loadNew"),
			this.$store.commit("khaosat/loadNew"),
		];
		await Promise.all(getInformation)
			.then(() => { })
			.catch((error) => {
				console.error(error, "error");
			});
	},
	watch: {
		"thisinh.soCmnd"(value) {
			if (value.length <= 9) {
				return (this.length_CMND = 9);
			} else {
				return (this.length_CMND = 12);
			}
		},
	},
	mounted() {
		this.$root.$dialogLoader = this.$refs.dialogLoader;
	},
};
